import React from "react";
import { graphql } from "react-apollo";
import { flowRight as compose } from "lodash";
import gql from "graphql-tag";
import {connect} from "react-redux";
import Form from "./ProductDescriptionForm";
import {GET_PRODUCT_DESCRIPTIONS} from "../../../queries/inventory";
import Loading from "../../../components/Loading";
import GraphQLErrors from "../../../components/GraphQLErrors";
import {cancelChangeProductBundleDescription} from "../../../actions/InventoryApiActions";
import {createValidationErrors, createErrors} from "../../../lib/ErrorFormatter";
import {validatePresence} from "../../../lib/Validators";
import {Map} from "immutable";

function validateForm(values) {
  let errors = Map();
  errors = validatePresence(errors, values, "title");
  return errors.toJS();
}

class ProductBundleDescriptionFormContainer extends React.Component {

  constructor(props) {
    super(props);
    this.state = { errors: [] }
  }

  handleSubmit(values) {
    return this.props.changeProductBundleDescription(values.toJS())
      .then((response) => {
        if (response.data.changeProductBundleDescription.errors.length <= 0) {
          this.props.cancelChangeProductBundleDescription();
        } else {
          let errors = createValidationErrors(response.data.changeProductBundleDescription.errors);
          this.setState({errors: errors});
        }
      })
      .catch((err) => {
        console.warn(err);
        this.setState({errors: createErrors(err)});
      });      
  }

  handleCancel() {
    this.props.cancelChangeProductBundleDescription();
  }

  render() {
    let {loading, error, product} = this.props.data;
    if (loading) return <Loading />
    if (error) return <GraphQLErrors error={error} />
   
    let values = {
      sku: product.sku,
      title: product.title,
      description: product.description
    }
    return (
      <Form
        initialValues={values}
        errors={this.state.errors}
        validate={validateForm}
        onSubmit={this.handleSubmit.bind(this)}
        onCancel={this.handleCancel.bind(this)}
        />
    )
  }

}


const CHANGE_PRODUCT_BUNDLE_DESCRIPTIONS = gql`
  mutation changeProductBundleDescription($data: ProductDescriptionInput!) {
    changeProductBundleDescription(input: $data) {
      errors { key message }
    }
  }
`;

const withProductQuery = compose(
  graphql(GET_PRODUCT_DESCRIPTIONS, {
    options: (props) => ({
      variables: {
        sku: props.sku
      },
      cachePolicy: "network-only",
      name: "getProductDescription"
    })
  }),
  graphql(CHANGE_PRODUCT_BUNDLE_DESCRIPTIONS, {
    props: ({ mutate }) => ({
      changeProductBundleDescription: (data) => mutate({
        variables: { data: data }
      })
    })
  })  
);

const ProductBundleDescriptionFormContainerWithData = withProductQuery(ProductBundleDescriptionFormContainer);



export default connect(null, {cancelChangeProductBundleDescription})(ProductBundleDescriptionFormContainerWithData);